const t = "Enter 키를 눌러 수정", e = {
  pressEnterToEdit: t
};
export {
  e as default,
  t as pressEnterToEdit
};
